import { render } from "./CustomerRates.vue?vue&type=template&id=1be5bda7&ts=true"
import script from "./CustomerRates.vue?vue&type=script&lang=ts"
export * from "./CustomerRates.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__